import { useRequest } from '@hourly/hooks/useRequest';
import { useState } from 'react';
import { getDocumentLink, signDocument } from './requests/signDocuments.request';

export const useSignDocuments = () => {
  const [documentUrl, setDocumentUrl] = useState('');

  const { request: getDocumentsLink, status: getDocumentsLinkStatus } = useRequest(
    async ({ partnerId, partnerUserId }: { partnerId: string; partnerUserId: string }, options) => {
      const url = await getDocumentLink(partnerId, partnerUserId, options!.signal);
      setDocumentUrl(url);
    }
  );

  const { request: signDocuments, status: signDocumentsStatus } = useRequest(
    async (partnerId: string) => {
      await signDocument(partnerId);
      setDocumentUrl('');
    }
  );

  const cleanDocumentUrl = () => {
    setDocumentUrl('');
  };

  return {
    documentUrl,
    isSignDocumentsLoading: getDocumentsLinkStatus.isLoading || signDocumentsStatus.isLoading,
    isRequestingDocumentUrl: getDocumentsLinkStatus.isLoading,
    getDocumentsLink,
    signDocuments,
    cleanDocumentUrl,
  };
};
